module.exports = __webpack_public_path__ + "static/media/Frame 1.960d54f4.png";